
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'LinksFooter'
})
export default class LinksFooter extends Vue {}
